import { BlogCreationPayload } from "@modules/blog/types";

import { IBlogContent, ICreateBlogFormData, ImageCreationType } from "./types";

export const prepareImageUploadPromises = (
  data: ICreateBlogFormData,
  createImage: ImageCreationType
) => {
  const list = data?.content?.map(({ image }) => {
    if (!(image instanceof FileList)) {
      return Promise.resolve(image)
    }

    const formData = new FormData();

    formData.append('files[]', image[0]);

    const response = createImage(formData).unwrap()

    return response
  })

  return list
};

export const checkIfDescExist = (item: IBlogContent) => {
  return {
    ...item,
    descriptionAm: item?.descriptionAm || null,
    descriptionEn: item?.descriptionEn || null,
    descriptionRu: item?.descriptionRu || null,
  }
}

export const prepareClonedData = (
  data: ICreateBlogFormData,
  imagePaths: string[],
  idParam: string | undefined
): BlogCreationPayload => {
  const { content, ...restData } = data

  return {
    ...restData,
    content: content?.map(({ id, ...restitem }, index) => {
      if (idParam) {
        return {
          id,
          ...checkIfDescExist(restitem),
          image: imagePaths[index] || '',
        }
      }

      return {
        ...checkIfDescExist(restitem),
        image: imagePaths[index] || '',
      }
    }),
  } as unknown as BlogCreationPayload;
};
